import { fetcher } from "../../../utils/Axios";
import { useMutation } from "@tanstack/react-query";
import { getAuthValue, resetAuthValue } from "./useAuthValue";
import { resetSelectedHospitalValue } from "../../hospitalModule/hooks/useSelectedHospitalValue";
import { queryClient } from "../../../utils/ReactQueryConfig";
import { resetFilterValue } from "../../dashboardModule/hooks/useFilterValue";
import { resetCopilotValue } from "../../copilotModule/hooks/useCopilotValue";
import { ROUTE_NAME } from "../../../router/types/CommonTypes";

export const appReset = () => {
  queryClient.clear();
  resetAuthValue();
  resetFilterValue();
  resetSelectedHospitalValue();
  resetCopilotValue();
  window.location.href = ROUTE_NAME.ROOT;
};

async function logout() {
  const { refresh_token, userId, realm } = getAuthValue();
  return fetcher({
    url: "users/logout",
    method: "POST",
    headers: {
      "x-user-id": userId,
      "x-realm": realm,
      "x-refresh-token": refresh_token,
    },
  });
}

export default function useLogoutMutation(cb?: () => void) {
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      appReset();
      cb?.();
    },
  });
}
